import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';
import { SharedModule } from 'src/app/shared/shared.module';

@Component({
  selector: 'header-marketplace',
  template: `
    <div
      class="alain-default__nav-item hide-this"
      (click)="openMarketplace()"
      nz-tooltip
      nzTooltipTitle="Marketplace"
      nzTooltipPlacement="bottom"
    >
      <i nz-icon nzIconfont="icon-marketplace-black"></i>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SharedModule]
})
export class HeaderMarketplaceComponent {
  constructor(private readonly router: Router) {}
  openMarketplace() {
    this.router.navigate(['./marketplace/partners']);
  }
}
